"use strict";

var _classCallCheck = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var web3_shim_1 = require("./web3-shim");

var Web3InterfaceAdapter =
/*#__PURE__*/
function (_web3_shim_1$Web3Shim) {
  _inherits(Web3InterfaceAdapter, _web3_shim_1$Web3Shim);

  function Web3InterfaceAdapter(options) {
    _classCallCheck(this, Web3InterfaceAdapter);

    return _possibleConstructorReturn(this, _getPrototypeOf(Web3InterfaceAdapter).call(this, options));
  }

  _createClass(Web3InterfaceAdapter, [{
    key: "getNetworkId",
    value: function getNetworkId() {
      return this.eth.net.getId();
    }
  }]);

  return Web3InterfaceAdapter;
}(web3_shim_1.Web3Shim);

exports.Web3InterfaceAdapter = Web3InterfaceAdapter;